// eZelo. - Ícones Minimalistas e Refinados
// Design: Clean, thin strokes, luxurious feel

export const IconCleaning = ({ className = "" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="8" r="5" />
    <path d="M12 13v8" />
    <path d="M8 21h8" />
  </svg>
);

export const IconGarden = ({ className = "" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 21V11" />
    <path d="M8 21h8" />
    <path d="M12 11C12 11 8 8 8 5C8 2 12 2 12 2C12 2 16 2 16 5C16 8 12 11 12 11Z" />
    <path d="M6 13C4 11 4 8 6 6" />
    <path d="M18 13C20 11 20 8 18 6" />
  </svg>
);

export const IconPool = ({ className = "" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 12C4 10 6 14 8 12C10 10 12 14 14 12C16 10 18 14 20 12C22 10 22 12 22 12" />
    <path d="M2 17C4 15 6 19 8 17C10 15 12 19 14 17C16 15 18 19 20 17C22 15 22 17 22 17" />
    <rect x="6" y="3" width="4" height="6" rx="1" />
    <rect x="14" y="3" width="4" height="6" rx="1" />
  </svg>
);

export const IconAirConditioner = ({ className = "" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="4" width="20" height="10" rx="2" />
    <path d="M6 17v4" />
    <path d="M10 17v2" />
    <path d="M14 17v4" />
    <path d="M18 17v2" />
    <path d="M6 8h12" />
  </svg>
);

export const IconRenovation = ({ className = "" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
  </svg>
);

export const IconConstruction = ({ className = "" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 21h18" />
    <path d="M5 21V7l7-4 7 4v14" />
    <path d="M9 21v-6h6v6" />
    <path d="M9 9h.01" />
    <path d="M15 9h.01" />
    <path d="M9 12h.01" />
    <path d="M15 12h.01" />
  </svg>
);

export const IconAssistant = ({ className = "" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <path d="M12 16v-4" />
    <path d="M12 8h.01" />
  </svg>
);

export const IconShield = ({ className = "" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    <path d="M9 12l2 2 4-4" />
  </svg>
);

export const IconContract = ({ className = "" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14,2 14,8 20,8" />
    <line x1="16" y1="13" x2="8" y2="13" />
    <line x1="16" y1="17" x2="8" y2="17" />
    <line x1="10" y1="9" x2="8" y2="9" />
  </svg>
);

export const IconSignature = ({ className = "" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 17c3.333-3.333 5-5 6.5-5 1.5 0 2 1.5 3.5 1.5 1.5 0 2-2 4-2 2 0 4 3 4 3" />
    <path d="M3 21h18" />
    <path d="M17 3l4 4-9 9H8v-4l9-9z" />
  </svg>
);

export const IconChat = ({ className = "" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    <path d="M8 9h8" />
    <path d="M8 13h4" />
  </svg>
);

export const IconWarning = ({ className = "" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
    <line x1="12" y1="9" x2="12" y2="13" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);

export const IconCheck = ({ className = "" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <path d="M9 12l2 2 4-4" />
  </svg>
);

export const IconLock = ({ className = "" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    <circle cx="12" cy="16" r="1" />
  </svg>
);

// Mapeamento de categorias para ícones
export const CATEGORY_ICONS = {
  cat_diarista: IconCleaning,
  cat_jardinagem: IconGarden,
  cat_piscina: IconPool,
  cat_arcondicionado: IconAirConditioner,
  cat_reforma: IconRenovation,
  cat_construcao: IconConstruction
};

// Configuração minimalista - cores neutras e sofisticadas
export const CATEGORY_CONFIG_MINIMAL = {
  cat_diarista: { 
    Icon: IconCleaning, 
    bg: "bg-stone-100", 
    text: "text-stone-700",
    label: "Limpeza" 
  },
  cat_jardinagem: { 
    Icon: IconGarden, 
    bg: "bg-stone-100", 
    text: "text-stone-700",
    label: "Jardim" 
  },
  cat_piscina: { 
    Icon: IconPool, 
    bg: "bg-stone-100", 
    text: "text-stone-700",
    label: "Piscina" 
  },
  cat_arcondicionado: { 
    Icon: IconAirConditioner, 
    bg: "bg-stone-100", 
    text: "text-stone-700",
    label: "Climatização" 
  },
  cat_reforma: { 
    Icon: IconRenovation, 
    bg: "bg-stone-100", 
    text: "text-stone-700",
    label: "Reforma" 
  },
  cat_construcao: { 
    Icon: IconConstruction, 
    bg: "bg-stone-100", 
    text: "text-stone-700",
    label: "Construção" 
  }
};
